import React from "react";
import { Plus, Trash2 } from "lucide-react";

/**
 * Template Yields editor. Each row: {name, qty_per_unit}.
 * Up to 15 rows.
 */
const MAX = 15;

const TemplateYieldsEditor = ({ rows = [], onChange, unit = "unit" }) => {
  const add = () => {
    if (rows.length >= MAX) return;
    onChange?.([
      ...rows,
      { _key: `y-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`, name: "", qty_per_unit: 0 },
    ]);
  };
  const update = (i, patch) =>
    onChange?.(rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
  const remove = (i) => onChange?.(rows.filter((_, idx) => idx !== i));

  return (
    <div className="flex flex-col gap-2" data-testid="template-yields-editor">
      {rows.length === 0 && (
        <div className="text-sm text-[#607087] italic">
          No template yields yet. Add one to compute cost-per-cover.
        </div>
      )}
      {rows.map((row, i) => (
        <div
          key={row._key || `legacy-${i}`}
          className="grid grid-cols-[1fr_5.5rem_auto_auto] items-center gap-2"
          data-testid={`yield-row-${i}`}
        >
          <input
            data-testid={`yield-name-${i}`}
            className="nb-input min-w-0"
            placeholder="Size e.g. Mens 9, Womens 7, XS"
            value={row.name}
            onChange={(e) => update(i, { name: e.target.value })}
          />
          <input
            data-testid={`yield-qty-${i}`}
            type="number"
            step="0.1"
            className="nb-input font-mono-num text-right"
            placeholder="0"
            value={row.qty_per_unit}
            onChange={(e) =>
              update(i, { qty_per_unit: Number(e.target.value) || 0 })
            }
          />
          <span className="label-eyebrow whitespace-nowrap text-[#607087]">/ {unit}</span>
          <button
            data-testid={`yield-remove-${i}`}
            onClick={() => remove(i)}
            className="nb-btn nb-btn-danger p-2"
            aria-label="remove"
            type="button"
          >
            <Trash2 size={14} strokeWidth={2.5} />
          </button>
        </div>
      ))}
      <div className="flex items-center justify-between gap-3 flex-wrap pt-1">
        {rows.length < MAX ? (
          <button
            data-testid="yield-add"
            onClick={add}
            type="button"
            className="nb-btn bg-white py-2 px-3 flex items-center gap-1 text-sm"
          >
            <Plus size={14} strokeWidth={2.5} /> Add size
          </button>
        ) : (
          <span />
        )}
        <div className="label-eyebrow">{rows.length}/{MAX} sizes</div>
      </div>
    </div>
  );
};

export default TemplateYieldsEditor;
